var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGrabberNsew = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "m9.5 12 1.5 1.5L8 16l-3-2.5L6.5 12 8 13.5zm4-7L16 8l-2.5 3L12 9.5 13.5 8 12 6.5zm-11 0L4 6.5 2.5 8 4 9.5 2.5 11 0 8zM10 9v1H6V9zm0-3v1H6V6zM8 0l3 2.5L9.5 4 8 2.5 6.5 4 5 2.5z"
})));
export default SvgGrabberNsew;